import React from "react";
import { Container, Row, Col } from "reactstrap";
import styles from "./contact.module.scss";
import Button from "../../elements/layout"

const ContactSection = () => (
    <div className="section" id="contact">
        <Container className={styles.section}>
            <Row>
                <Col>
                    <h2>Kontakt</h2>
                    <p className={styles.ctaText}>Neváhajte nás kontaktovať prostredníctvom emailu na:</p>
                    <a href="mailto:tp_06_2018@googlegroups.com"><Button dark>tp_06_2018@googlegroups.com</Button></a>
                </Col>
            </Row>
        </Container>
    </div>
);

export default ContactSection;
